import { Animal, AnimalDisease, AnimalVaccine, AnimalSurgicalOperation  } from './animal';
import { TranslateService } from '@ngx-translate/core';
import { ComptaInvoice } from './compta';
import { ComptaService } from '../services/compta.service';
import { DateUtilsService } from '../services/date-utils.service';

export class AgendaEventDocumentType {
    id: number | null = null;
    name: string | null = null;
}

export class AgendaEventType {
    id: number | null = null;
    name: string | null = null;
    isVet: boolean = false;
    isHeat: boolean = false;
    isReproductive: boolean = false;
    isTreatment: boolean = false;
    isDate: boolean = false;
    isEvent: boolean = false;
}

export class AgendaEventStatut {
    id: string | null = null;
    name: string | null = null;
}


export class AgendaEventDocument {
    id: number | null = null;
    file: string | null = null;
    fileName: string | null = null;
    base64: string | null = null;
    name: string | null = null;
    type: string = '99';
}

export class AgendaEvent {
    id: number | null = null;
    userId: number | null = null;
    animals: Animal[] = [];
    dateTimeStart: string | null = null;
    dateTimeEnd: string | null = null;
    hasEditRights: boolean = false;
    
    statut: AgendaEventStatut | null = null;
    type: AgendaEventType | null = null;
    comment: string = '';

    reports: AgendaEventReport[] = [];
    documents: AgendaEventDocument[] = [];

    treatmentIsSuccess: boolean = false;
    treatmentDuration: number = 8;
    treatmentDurationUnit: string = 'week';
    treatmentIsRecurring: boolean = false;
    treatmentIsPonctual: boolean = true;

    createdFromEventId: number | null = null;


    dateTimeStartIsPast(dateUtils: DateUtilsService): boolean {
        return (dateUtils.fromString(this.dateTimeStart) ?? new Date()) < new Date()
    }

    getInvoices(comptaService: ComptaService) {
        return comptaService.invoices.filter( (invoice: ComptaInvoice) => invoice.eventId === this.id);
    }

    amount(comptaService: ComptaService): number {
        let amount: number = 0
        for(let invoice of this.getInvoices(comptaService)) {
            amount += invoice.amount
        }
        return amount;
    }

    getIcon(): string | null {
        if(this.type?.isVet) {
            return '/assets/icon/vet.png';
        } else if(this.type?.isTreatment) {
            if(this.type?.id == 4)
                return '/assets/icon/fleas.png'
            if(this.type?.id == 5)
                return '/assets/icon/worms.png'
            return '/assets/icon/treatment.png';
        }

        return null;
    }
}

export class AgendaEventReportDocument {
    id: number | null = null;
    file: string | null = null;
    fileName: string | null = null;
    base64: string | null = null;
    name: string | null = null;
    type: string = '99';
}

export class AgendaEventReport {
    id: number | null = null;
    animal: Animal | null = null;
    report: string = '';
    isNothingToReport: boolean = false;
    isNoTreatment: boolean = false;
    treatment: AgendaEvent | null = null;
    diseases: AnimalDisease[] = [];
    surgicalOperations: AnimalSurgicalOperation[] = [];
    documents: AgendaEventReportDocument[] = [];
    weight: number | null = null;
    vaccines: AnimalVaccine[] = [];
}